'use strict';

import query from './query';

const MODULE_NAME = 'daupler.mappy';

var app = angular.module(MODULE_NAME, [
]);
app.directive('mappyQuery', query);

export default MODULE_NAME;
